import { render, staticRenderFns } from "./DescargarContratos.vue?vue&type=template&id=cbb2d2a4&scoped=true"
import script from "./DescargarContratos.vue?vue&type=script&lang=js"
export * from "./DescargarContratos.vue?vue&type=script&lang=js"
import style0 from "./DescargarContratos.vue?vue&type=style&index=0&id=cbb2d2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb2d2a4",
  null
  
)

export default component.exports